export const REQUEST_CREATE_UNKNOWN_VEHICLE =
  'src/UnknownRegPage/REQUEST_CREATE_UNKNOWN_VEHICLE'
export const REQUEST_CREATE_UNKNOWN_VEHICLE_SUCCESS =
  'src/UnknownRegPage/REQUEST_CREATE_UNKNOWN_VEHICLE_SUCCESS'
export const REQUEST_CREATE_UNKNOWN_VEHICLE_FAILED =
  'src/UnknownRegPage/REQUEST_CREATE_UNKNOWN_VEHICLE_FAILED'

export const CREATE_UNKNOWN_VEHICLE_LINK_REL = 'TODO'
